'use client'

import { ReactNode, Suspense } from 'react'
import { AuthContextProvider } from '@/app/firebase/AuthContext'
import { SidebarProvider } from '@/components/sidebar-context'
import { AuthGate } from '@/components/AuthGate'

/**
 * Client-side providers wrapper
 * This component wraps children with context providers
 * Even when JS is disabled, Next.js will render the HTML structure server-side
 * The children will always be visible, even if context functionality doesn't work
 */
export function ClientProviders({ children }: { children: ReactNode }) {
  // Always render children - context providers will enhance functionality when JS is available
  // But children will be visible even without JS due to SSR
  return (
    <AuthContextProvider>
      <SidebarProvider>
        <Suspense fallback={null}>
          <AuthGate>
            {children}
          </AuthGate>
        </Suspense>
      </SidebarProvider>
    </AuthContextProvider>
  )
}
